webpackJsonp([53180022437869],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/utilities-index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Link = __webpack_require__("./src/components/Link.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _PageHeader = __webpack_require__("./src/components/PageHeader.js");
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Card = __webpack_require__("./src/components/Card.js");
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	    var data = _ref.data;
	    var posts = data.allMarkdownRemark.edges;
	
	
	    return _react2.default.createElement(
	        "div",
	        { className: "l-container" },
	        posts.filter(function (post) {
	            return post.node.frontmatter.group == 'utilities';
	        }).map(function (_ref2) {
	            var post = _ref2.node;
	
	            if (post.frontmatter.layout === "utilities-index") {
	                return _react2.default.createElement(_PageHeader2.default, {
	                    title: post.frontmatter.title,
	                    description: post.frontmatter.description
	                });
	            }
	        }),
	        _react2.default.createElement(
	            "ul",
	            { className: "c-card-list l-grid l-grid--3up" },
	            posts.filter(function (post) {
	                return post.node.frontmatter.group == 'utilities';
	            }).map(function (_ref3) {
	                var post = _ref3.node;
	
	                if (post.frontmatter.layout != "utilities-index") {
	                    return _react2.default.createElement(
	                        "li",
	                        { className: "l-grid__item" },
	                        _react2.default.createElement(_Card2.default, { href: post.frontmatter.path, title: post.frontmatter.title, description: post.frontmatter.description, key: post.id })
	                    );
	                }
	            })
	        )
	    );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-utilities-index-js-30710811037efcc0487d.js